import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-627a8e91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-filters" }
const _hoisted_2 = { class: "search-username" }
const _hoisted_3 = ["onKeyup", "placeholder"]

import { ref } from 'vue'
  import { useRoute } from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  emits: ['filterOnUsername'],
  setup(__props, { emit }) {

  const route = useRoute()
  const username = ref(route.query.q ? route.query.q : '')

  
  function searchUsers() {
    if (username.value !== '') {
      emit('filterOnUsername', username)
    }
  }
  function resetFilter() {
    username.value = ''
    emit('filterOnUsername', username.value)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "username",
        name: "username",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
        onKeyup: _withKeys(searchUsers, ["enter"]),
        placeholder: _ctx.$t('user.FILTER_ON_USERNAME')
      }, null, 40, _hoisted_3), [
        [
          _vModelText,
          username.value,
          void 0,
          { trim: true }
        ]
      ]),
      (username.value !== '')
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fa fa-times",
            "aria-hidden": "true",
            onClick: resetFilter
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("i", {
      class: _normalizeClass(["fa fa-search", { 'fa-disabled': username.value === '' }]),
      "aria-hidden": "true",
      onClick: searchUsers
    }, null, 2)
  ]))
}
}

})